import {
  mapActions
} from 'vuex'

export default {
  name: 'Login',
  data: function () {
    return {
      isLoginFiled: false,
      email: '', // 'a.khovbok@gmail.com', //'dev.itprint', //'test',
      password: '', // 123123, //'1q2w3e4r5t', //'qweqwe123123',
      remember: false,
      isDeactivated: false
    }
  },
  computed: {
    isInvalid () {
      return Object.values(this.fields).some(x => x.invalid)
    }
  },
  methods: {
    login () {
      if (this.isInvalid) return
      this.isLoginFiled = false
      const creds = {
        email: this.email,
        password: this.password,
        remember: this.remember
      }
      this.loginUser(creds)
        .then(() => {
          this.$store.getters.role === 'ROLE_SUPER_ADMIN' ? this.$router.push('/admin') : this.$router.push('/')
        })
        .catch((ex) => {
          if (ex?.response?.data?.error === 'User account is disabled.') {
            this.isDeactivated = true
          } else {
            this.isLoginFiled = true
          }
        })
    },
    ...mapActions({
      loginUser: 'LOGIN_USER'
    })
  }
}
